import { ONE_SECOND } from '#constants';
export const TOAST_KIND = {
    INFORMATIVE: 'informative',
    POSITIVE: 'positive',
    NEGATIVE: 'negative',
    PROGRESSIVE: 'progressive',
};
export const TOAST_DISMISS_TIMEOUTS = {
    fast: 5 * ONE_SECOND,
    slow: 7 * ONE_SECOND,
    never: Number.POSITIVE_INFINITY,
};
export const FADE_ANIMATION_DURATION = ONE_SECOND / 2;
export const DISPLAY_TOASTS_COUNT = 10;
